// import displayHelper from "@/util/display_helper"
// import datetimeHelper from "@/util/datetime_helper"
import model from "@/model"

export default function (copy) {
  let object;
  if (copy) {
    object = JSON.parse(JSON.stringify(copy));
  } else {
    object = [model.inventoryResponse()];
  }
  object.hasDevices = function hasDevices() {
    return object ? object.length > 0 ? true : false : false;
  }
  object.hasMultipleDevices = function hasMultipleDevices() {
    return object ? object.length > 1 ? true : false : false;
  }
  object.getDevices = function getDevices() {
    let devices = [];
    if (object.hasDevices()) {
      object.forEach((data) => {
        devices.push(model.inventoryResponse(data));
      });
    }

    return devices;
  }

  return object;
}

